import { render, staticRenderFns } from "./PetsStep.vue?vue&type=template&id=4cc486d3&scoped=true&"
import script from "./PetsStep.vue?vue&type=script&lang=js&"
export * from "./PetsStep.vue?vue&type=script&lang=js&"
import style0 from "./PetsStep.vue?vue&type=style&index=0&id=4cc486d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc486d3",
  null
  
)

export default component.exports